import {
	type IBeneficiary,
	type ICurrencyDropDownItem,
	type IMeta,
	type IUseFormStage,
	type IUseWalletAddressProviderApi,
	type IWalletProps,
	narrationValidation,
	selectedBeneficiarySchema,
} from 'BreetHelpers';
import type { UseFormReturn } from 'react-hook-form';
import * as yup from 'yup';

export type FIATWITHDRAWREQUESTSTAGETYPE = 'withdraw-funds' | 'add-beneficiary' | 'withdraw-details' | 'manage-beneficiaries';

export const requestPaymentStageTitle: Record<FIATWITHDRAWREQUESTSTAGETYPE, string> = {
	'withdraw-funds': 'Withdraw',
	'add-beneficiary': 'Add Bank Account',
	'withdraw-details': 'Withdrawal Confirmation',
	'manage-beneficiaries': 'Manage Accounts',
};

export interface IFiatWithdrawRequestContext {
	userWalletProps: IWalletProps;
	meta?: IMeta;
	withdrawRequestHookForm: UseFormReturn<CreateWithdrawRequestFormSchemaType>;
	formStage: IUseFormStage<FIATWITHDRAWREQUESTSTAGETYPE>;
	beneficiaries: IBeneficiary[];
}

export const CreateWithdrawRequestFormSchema = yup.object({
	amount: yup.string().required('Amount details required'),
	selectedBeneficiary: selectedBeneficiarySchema,
	narration: narrationValidation,
});

export type CreateWithdrawRequestFormSchemaType = yup.InferType<typeof CreateWithdrawRequestFormSchema>;

export interface IWithdrawRequestContext {
	selectedWallet?: ICurrencyDropDownItem;
	selectWallet?: (wallet: ICurrencyDropDownItem) => void;
}

export type USDWITHDRAWREQUESTSTAGETYPE =
	| 'withdraw-funds'
	| 'add-wallet-address'
	| 'saved-wallet-address'
	| 'manage-wallet-address'
	| 'scan-wallet-address'
	| 'crypto-transaction-details';

export const requestPaymentUsdStageTitle: Record<USDWITHDRAWREQUESTSTAGETYPE, string> = {
	'withdraw-funds': 'Withdraw Stablecoin',
	'saved-wallet-address': 'Saved Address',
	'add-wallet-address': 'Add Wallet Address',
	'manage-wallet-address': 'Manage Address',
	'scan-wallet-address': 'Scan Address',
	'crypto-transaction-details': 'Withdraw Stablecoin Details',
};

export interface IUsdWithdrawRequestContext extends IUseWalletAddressProviderApi {
	formStage: IUseFormStage<USDWITHDRAWREQUESTSTAGETYPE>;
}
